import { type FC, useState } from 'react'
import classNames from 'classnames'
import { Modal } from '../../Modal/Modal'
import { RANGE_PERIOD_TEXT } from '../userScoreRange'
import styles from './WhatsCounted.module.scss'

const NOT_COUNTED = [
  'Private meetings.',
  'Meetings with no client added.',
  'Meetings before scoring was turned on for your account.',
  "Meetings that couldn't be scored, for example a meeting too short to assess.",
]

interface WhatsCountedProps {
  periodText?: string
}

// Reads as the closing words of the tagline it is appended to, and opens the explainer
export const WhatsCounted: FC<WhatsCountedProps> = ({ periodText = RANGE_PERIOD_TEXT['90d'] }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button type='button' className={classNames('zocks-text-primary', styles.inlineLink)} onClick={() => setOpen(true)}>
        What&apos;s counted
      </button>
      <Modal
        show={open}
        onHide={() => setOpen(false)}
        centered
        headerBodySeparator
        header={<h5 className='mb-0'>What&apos;s counted</h5>}
        body={
          <div className='d-flex flex-column zocks-gap-1'>
            <p className='paragraph-medium zocks-text-gray-900 mb-0'>Scored meetings from the {periodText}.</p>
            <div className='d-flex flex-column zocks-gap-0.25'>
              <span className='paragraph-medium bold zocks-text-gray-900'>Not counted:</span>
              <ul className={classNames('paragraph-medium zocks-text-gray-700 mb-0', styles.notCountedList)}>
                {NOT_COUNTED.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <p className='paragraph-medium zocks-text-gray-700 mb-0'>
              This is why the number here can be lower than the number of meetings shown in Past Meetings.
            </p>
          </div>
        }
      />
    </>
  )
}
